import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type { OrderView, WoltStatusActionRequest, WoltVenueStatusView } from 'shared-models/browser';

export type { WoltStatusAction, WoltStatusActionRequest, WoltVenueStatusView } from 'shared-models/browser';

class PosWoltService {
  // Manager-only venue availability readback; the backend asks Wolt, nothing is cached locally.
  async getVenueStatus(tenantId: string, employeeSession: string): Promise<WoltVenueStatusView> {
    try {
      const response = await authenticatedInstance.get<WoltVenueStatusView>(`/wolt/tenant/${tenantId}/venue/status`, {
        headers: { 'x-employee-session': employeeSession },
      });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'קריאת סטטוס הסניף בוולט נכשלה'));
    }
  }

  async setVenueOnline(tenantId: string, employeeSession: string, online: boolean): Promise<WoltVenueStatusView> {
    try {
      const response = await authenticatedInstance.post<WoltVenueStatusView>(
        `/wolt/tenant/${tenantId}/venue/online`,
        { online },
        { headers: { 'x-employee-session': employeeSession } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון סטטוס הסניף בוולט נכשל'));
    }
  }

  // POS lifecycle action (accept / reject / ready / delivered); the backend calls Wolt first.
  async applyStatus(
    tenantId: string,
    employeeSession: string,
    orderId: number,
    payload: WoltStatusActionRequest,
  ): Promise<OrderView> {
    try {
      const response = await authenticatedInstance.post<OrderView>(
        `/wolt/tenant/${tenantId}/orders/${orderId}/status`,
        payload,
        { headers: { 'x-employee-session': employeeSession } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'עדכון ההזמנה בוולט נכשל'));
    }
  }
}

export const posWoltService = new PosWoltService();
